var ELEMENT_BONDS = [
    {
        "elements": [
            "H",
            "H"
        ],
        "energy": {
            "value": 4.4773799,
            "units": "eV"
        },
        "length": {
            "value": 0.74,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "B"
        ],
        "energy": {
            "value": 4.03171477,
            "units": "eV"
        },
        "length": {
            "value": 1.19,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "C"
        ],
        "energy": {
            "value": 4.25972949,
            "units": "eV"
        },
        "length": {
            "value": 1.09,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Si"
        ],
        "energy": {
            "value": 3.2958491,
            "units": "eV"
        },
        "length": {
            "value": 1.48,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Ge"
        ],
        "energy": {
            "value": 2.98491994,
            "units": "eV"
        },
        "length": {
            "value": 1.53,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Sn"
        ],
        "energy": {
            "value": 2.60144064,
            "units": "eV"
        },
        "length": {
            "value": 1.7,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "N"
        ],
        "energy": {
            "value": 4.00062186,
            "units": "eV"
        },
        "length": {
            "value": 1.01,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "P"
        ],
        "energy": {
            "value": 3.33730632,
            "units": "eV"
        },
        "length": {
            "value": 1.44,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "As"
        ],
        "energy": {
            "value": 2.55998342,
            "units": "eV"
        },
        "length": {
            "value": 1.52,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "O"
        ],
        "energy": {
            "value": 4.75721615,
            "units": "eV"
        },
        "length": {
            "value": 0.96,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "S"
        ],
        "energy": {
            "value": 3.76224284,
            "units": "eV"
        },
        "length": {
            "value": 1.34,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Se"
        ],
        "energy": {
            "value": 2.86054827,
            "units": "eV"
        },
        "length": {
            "value": 1.46,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "T"
        ],
        "energy": {
            "value": 2.46670467,
            "units": "eV"
        },
        "length": {
            "value": 1.7,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "F"
        ],
        "energy": {
            "value": 5.85583251,
            "units": "eV"
        },
        "length": {
            "value": 0.92,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Cl"
        ],
        "energy": {
            "value": 4.43592268,
            "units": "eV"
        },
        "length": {
            "value": 1.27,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "Br"
        ],
        "energy": {
            "value": 3.75187853,
            "units": "eV"
        },
        "length": {
            "value": 1.41,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "H",
            "I"
        ],
        "energy": {
            "value": 3.05747007,
            "units": "eV"
        },
        "length": {
            "value": 1.61,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "N",
            "N"
        ],
        "energy": {
            "value": 1.73083899,
            "units": "eV"
        },
        "length": {
            "value": 1.45,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "N",
            "N"
        ],
        "energy": {
            "value": 4.33227963,
            "units": "eV"
        },
        "length": {
            "value": 1.25,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "N",
            "N"
        ],
        "energy": {
            "value": 9.76317562,
            "units": "eV"
        },
        "length": {
            "value": 1.1,
            "units": "angstrom"
        },
        "order": 3
    },
    {
        "elements": [
            "N",
            "O"
        ],
        "energy": {
            "value": 2.08322537,
            "units": "eV"
        },
        "length": {
            "value": 1.4,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "N",
            "O"
        ],
        "energy": {
            "value": 6.29113334,
            "units": "eV"
        },
        "length": {
            "value": 1.21,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "N",
            "F"
        ],
        "energy": {
            "value": 2.93309841,
            "units": "eV"
        },
        "length": {
            "value": 1.36,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "N",
            "Cl"
        ],
        "energy": {
            "value": 3.24402757,
            "units": "eV"
        },
        "length": {
            "value": 1.75,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "P"
        ],
        "energy": {
            "value": 2.08322537,
            "units": "eV"
        },
        "length": {
            "value": 2.21,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "O"
        ],
        "energy": {
            "value": 3.47204229,
            "units": "eV"
        },
        "length": {
            "value": 1.63,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "O"
        ],
        "energy": {
            "value": 5.6381821,
            "units": "eV"
        },
        "length": {
            "value": 1.5,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "P",
            "S"
        ],
        "energy": {
            "value": 3.47204229,
            "units": "eV"
        },
        "length": {
            "value": 1.86,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "P",
            "F"
        ],
        "energy": {
            "value": 5.07850961,
            "units": "eV"
        },
        "length": {
            "value": 1.54,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "Cl"
        ],
        "energy": {
            "value": 3.37876354,
            "units": "eV"
        },
        "length": {
            "value": 2.03,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "Br"
        ],
        "energy": {
            "value": 2.73617661,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "P",
            "I"
        ],
        "energy": {
            "value": 1.90703218,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "As"
        ],
        "energy": {
            "value": 1.51318858,
            "units": "eV"
        },
        "length": {
            "value": 2.43,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "O"
        ],
        "energy": {
            "value": 3.11965591,
            "units": "eV"
        },
        "length": {
            "value": 1.78,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "F"
        ],
        "energy": {
            "value": 5.01632378,
            "units": "eV"
        },
        "length": {
            "value": 1.71,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "Cl"
        ],
        "energy": {
            "value": 3.33730632,
            "units": "eV"
        },
        "length": {
            "value": 2.16,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "Br"
        ],
        "energy": {
            "value": 4.74685184,
            "units": "eV"
        },
        "length": {
            "value": 2.33,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "As",
            "I"
        ],
        "energy": {
            "value": 2.07286107,
            "units": "eV"
        },
        "length": {
            "value": 2.54,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sb",
            "Sb"
        ],
        "energy": {
            "value": 1.25408095,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sb",
            "F"
        ],
        "energy": {
            "value": 4.56029435,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sb",
            "Cl"
        ],
        "energy": {
            "value": 2.57034772,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sb",
            "Cl"
        ],
        "energy": {
            "value": 3.26475618,
            "units": "eV"
        },
        "length": {
            "value": 2.32,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "C"
        ],
        "energy": {
            "value": 3.58604965,
            "units": "eV"
        },
        "length": {
            "value": 1.54,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "C"
        ],
        "energy": {
            "value": 6.23931181,
            "units": "eV"
        },
        "length": {
            "value": 1.34,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "C",
            "C"
        ],
        "energy": {
            "value": 8.65419495,
            "units": "eV"
        },
        "length": {
            "value": 1.2,
            "units": "angstrom"
        },
        "order": 3
    },
    {
        "elements": [
            "C",
            "Si"
        ],
        "energy": {
            "value": 3.2958491,
            "units": "eV"
        },
        "length": {
            "value": 1.85,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "Ge"
        ],
        "energy": {
            "value": 2.46670467,
            "units": "eV"
        },
        "length": {
            "value": 1.95,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "Sn"
        ],
        "energy": {
            "value": 1.98994662,
            "units": "eV"
        },
        "length": {
            "value": 2.16,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "Pb"
        ],
        "energy": {
            "value": 1.34735969,
            "units": "eV"
        },
        "length": {
            "value": 2.3,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "N"
        ],
        "energy": {
            "value": 3.16111313,
            "units": "eV"
        },
        "length": {
            "value": 1.47,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "N"
        ],
        "energy": {
            "value": 6.37404778,
            "units": "eV"
        },
        "length": {
            "value": 1.29,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "C",
            "N"
        ],
        "energy": {
            "value": 9.19313883,
            "units": "eV"
        },
        "length": {
            "value": 1.16,
            "units": "angstrom"
        },
        "order": 3
    },
    {
        "elements": [
            "C",
            "P"
        ],
        "energy": {
            "value": 2.73617661,
            "units": "eV"
        },
        "length": {
            "value": 1.84,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "O"
        ],
        "energy": {
            "value": 3.71042131,
            "units": "eV"
        },
        "length": {
            "value": 1.43,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "O"
        ],
        "energy": {
            "value": 8.28107996,
            "units": "eV"
        },
        "length": {
            "value": 1.2,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "C",
            "O"
        ],
        "energy": {
            "value": 11.11053532,
            "units": "eV"
        },
        "length": {
            "value": 1.13,
            "units": "angstrom"
        },
        "order": 3
    },
    {
        "elements": [
            "C",
            "B"
        ],
        "energy": {
            "value": 3.6896927,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "S"
        ],
        "energy": {
            "value": 2.81909105,
            "units": "eV"
        },
        "length": {
            "value": 1.82,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "S"
        ],
        "energy": {
            "value": 5.93874696,
            "units": "eV"
        },
        "length": {
            "value": 1.6,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "C",
            "F"
        ],
        "energy": {
            "value": 5.02668809,
            "units": "eV"
        },
        "length": {
            "value": 1.35,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "Cl"
        ],
        "energy": {
            "value": 3.38912784,
            "units": "eV"
        },
        "length": {
            "value": 1.77,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "Br"
        ],
        "energy": {
            "value": 2.95382702,
            "units": "eV"
        },
        "length": {
            "value": 1.94,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "C",
            "I"
        ],
        "energy": {
            "value": 2.20759704,
            "units": "eV"
        },
        "length": {
            "value": 2.14,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "Si"
        ],
        "energy": {
            "value": 2.30087578,
            "units": "eV"
        },
        "length": {
            "value": 2.33,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "N"
        ],
        "energy": {
            "value": 3.67932839,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "O"
        ],
        "energy": {
            "value": 4.68466601,
            "units": "eV"
        },
        "length": {
            "value": 1.63,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "S"
        ],
        "energy": {
            "value": 3.03674146,
            "units": "eV"
        },
        "length": {
            "value": 2,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "F"
        ],
        "energy": {
            "value": 5.85583251,
            "units": "eV"
        },
        "length": {
            "value": 1.6,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "Cl"
        ],
        "energy": {
            "value": 3.94880033,
            "units": "eV"
        },
        "length": {
            "value": 2.02,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "Br"
        ],
        "energy": {
            "value": 3.21293465,
            "units": "eV"
        },
        "length": {
            "value": 2.15,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Si",
            "I"
        ],
        "energy": {
            "value": 2.42524745,
            "units": "eV"
        },
        "length": {
            "value": 2.43,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "Ge"
        ],
        "energy": {
            "value": 1.9484894,
            "units": "eV"
        },
        "length": {
            "value": 2.41,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "N"
        ],
        "energy": {
            "value": 2.66362647,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "F"
        ],
        "energy": {
            "value": 4.87122351,
            "units": "eV"
        },
        "length": {
            "value": 1.68,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "Cl"
        ],
        "energy": {
            "value": 3.61714256,
            "units": "eV"
        },
        "length": {
            "value": 2.1,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "Br"
        ],
        "energy": {
            "value": 2.86054827,
            "units": "eV"
        },
        "length": {
            "value": 2.3,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Ge",
            "I"
        ],
        "energy": {
            "value": 2.19723273,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sn",
            "F"
        ],
        "energy": {
            "value": 4.29082241,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sn",
            "Cl"
        ],
        "energy": {
            "value": 3.34767062,
            "units": "eV"
        },
        "length": {
            "value": 2.33,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sn",
            "Br"
        ],
        "energy": {
            "value": 2.82945536,
            "units": "eV"
        },
        "length": {
            "value": 2.5,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Sn",
            "I"
        ],
        "energy": {
            "value": 2.12468259,
            "units": "eV"
        },
        "length": {
            "value": 2.7,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Pb",
            "F"
        ],
        "energy": {
            "value": 3.43058507,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Pb",
            "Cl"
        ],
        "energy": {
            "value": 2.5185262,
            "units": "eV"
        },
        "length": {
            "value": 2.42,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Pb",
            "Br"
        ],
        "energy": {
            "value": 2.08322537,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Pb",
            "I"
        ],
        "energy": {
            "value": 1.47173136,
            "units": "eV"
        },
        "length": {
            "value": 2.79,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "B",
            "B"
        ],
        "energy": {
            "value": 3.03674146,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "B",
            "O"
        ],
        "energy": {
            "value": 5.55526766,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "B",
            "F"
        ],
        "energy": {
            "value": 6.35331917,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "B",
            "Cl"
        ],
        "energy": {
            "value": 4.72612323,
            "units": "eV"
        },
        "length": {
            "value": 1.75,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "B",
            "Br"
        ],
        "energy": {
            "value": 3.90734311,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "O",
            "O"
        ],
        "energy": {
            "value": 1.47173136,
            "units": "eV"
        },
        "length": {
            "value": 1.48,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "O",
            "O"
        ],
        "energy": {
            "value": 5.11996683,
            "units": "eV"
        },
        "length": {
            "value": 1.21,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "O",
            "F"
        ],
        "energy": {
            "value": 1.96921801,
            "units": "eV"
        },
        "length": {
            "value": 1.42,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "S",
            "O"
        ],
        "energy": {
            "value": 5.41016738,
            "units": "eV"
        },
        "length": {
            "value": 1.43,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "S",
            "S"
        ],
        "energy": {
            "value": 2.34233301,
            "units": "eV"
        },
        "length": {
            "value": 2.05,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "S",
            "S"
        ],
        "energy": {
            "value": 4.40482977,
            "units": "eV"
        },
        "length": {
            "value": 1.49,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "S",
            "F"
        ],
        "energy": {
            "value": 2.94346271,
            "units": "eV"
        },
        "length": {
            "value": 1.56,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "S",
            "Cl"
        ],
        "energy": {
            "value": 2.64289786,
            "units": "eV"
        },
        "length": {
            "value": 2.07,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Se",
            "Se"
        ],
        "energy": {
            "value": 1.78266052,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Se",
            "Se"
        ],
        "energy": {
            "value": 2.81909105,
            "units": "eV"
        },
        "length": {
            "value": 2.15,
            "units": "angstrom"
        },
        "order": 2
    },
    {
        "elements": [
            "F",
            "F"
        ],
        "energy": {
            "value": 1.60646733,
            "units": "eV"
        },
        "length": {
            "value": 1.42,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Cl",
            "Cl"
        ],
        "energy": {
            "value": 2.48743328,
            "units": "eV"
        },
        "length": {
            "value": 1.99,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "Br",
            "Br"
        ],
        "energy": {
            "value": 1.96921801,
            "units": "eV"
        },
        "length": {
            "value": 2.28,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "I",
            "I"
        ],
        "energy": {
            "value": 1.53391719,
            "units": "eV"
        },
        "length": {
            "value": 2.67,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "At",
            "At"
        ],
        "energy": {
            "value": 1.20225942,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "I",
            "O"
        ],
        "energy": {
            "value": 2.08322537,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "I",
            "F"
        ],
        "energy": {
            "value": 2.82945536,
            "units": "eV"
        },
        "length": {
            "value": 1.91,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "I",
            "Cl"
        ],
        "energy": {
            "value": 2.15577551,
            "units": "eV"
        },
        "length": {
            "value": 2.32,
            "units": "angstrom"
        },
        "order": 1
    },
    {
        "elements": [
            "I",
            "Br"
        ],
        "energy": {
            "value": 1.81375343,
            "units": "eV"
        },
        "length": {
            "value": 0,
            "units": "angstrom"
        },
        "order": 1
    }
]

exports.ELEMENT_BONDS = ELEMENT_BONDS